import PropTypes from "prop-types";
import { CustomContainer } from "../../../atoms/DependencyHelper";
import styles from "./FormInlineDetails.module.scss";

const FormInlineDetails = ({
  className,
  title,
  value,
  subvalue,
  type,
  applicationType,
  handleOnEdit
}) => {
  function contentValue(val) {
    if (val && val !== "") {
      if (Array.isArray(val) && val.length > 0) {
        return val.join(", ");
      } else {
        return val;
      }
    } else {
      return "None";
    }
  }

  return (
    <>
      <CustomContainer className={`${className} ${styles["inline-details"]}`}>
        {title && <div className={styles["title"]}>{title}</div>}
        <div className={styles["value"]}>
          {value !== "" ? (
            <span className={styles["value__first"]}>
              {contentValue(value)}
            </span>
          ) : null}

          <span className={styles["value__second"]}>
            {subvalue ? contentValue(subvalue) : "None"}
          </span>

          {applicationType == "normal" ?   (
            <span
              className={styles["value__change"]}
              id={`${title}-changes`}
              onClick={event => {
                handleOnEdit(type);
              }}
            >
              {type == "instructions" && value == ""
                ? "Add Instructions"
                : "Change"}
            </span>
          ): null}
        </div>
      </CustomContainer>
    </>
  );
};

FormInlineDetails.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string,
  value: PropTypes.string,
  subvalue: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  type: PropTypes.string,
  handleOnEdit: PropTypes.func,
  applicationType: PropTypes.string,
};

FormInlineDetails.defaultProps = {
  type: "delivery",
  applicationType: "normal",
};

export default FormInlineDetails;
